import React from 'react';
import { Link } from 'react-router-dom';
import { Library, Users } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../../hooks/useAuth';
import { PageLayout } from '../../components/layout/PageLayout';
import { AdSense } from '../../components/ads/AdSense';
import { useI18n } from '../../contexts/I18nContext';

export function DeckChoice() {
  const { user } = useAuth();
  const { t, getPathForLang } = useI18n();

  return (
    <PageLayout>
      <Helmet>
        <title>{t('deck_choice.seo.title')}</title>
        <meta name="description" content={t('deck_choice.seo.description')} />
      </Helmet>
      
      <div className="container mx-auto px-4 py-6 pb-8 md:pb-8">
        {/* Annonce AdSense unique */}
        <div className="mt-6 mb-8 flex justify-center items-center">
          <AdSense adSlot="1424794127" />
        </div>
        
        {/* Section principale */}
        <div className="space-y-6 max-w-lg mx-auto">
          {/* Decks */}
          <div>
            <h2 className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-3 px-2">
              {t('deck_choice.category_title')}
            </h2>
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
              {user && (
                <Link
                  to={getPathForLang('/decks')}
                  className="flex items-center p-4 border-b border-gray-100 hover:bg-blue-50 transition-colors"
                >
                  <div className="bg-indigo-100 p-3 rounded-full">
                    <Library className="w-5 h-5 text-indigo-600" />
                  </div>
                  <div className="ml-3">
                    <h2 className="font-semibold text-gray-900">{t('deck_choice.my_decks.title')}</h2>
                    <p className="text-xs text-gray-600">{t('deck_choice.my_decks.description')}</p>
                  </div>
                </Link>
              )}

              <Link
                to={getPathForLang('/public-decks')}
                className="flex items-center p-4 hover:bg-blue-50 transition-colors"
              >
                <div className="bg-blue-100 p-3 rounded-full">
                  <Users className="w-5 h-5 text-blue-600" />
                </div>
                <div className="ml-3">
                  <h2 className="font-semibold text-gray-900">{t('deck_choice.public_decks.title')}</h2>
                  <p className="text-xs text-gray-600">{t('deck_choice.public_decks.description')}</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
} 